// Values shared across Board.js's render subtree. Values that are only
// coincidentally equal (e.g. BASE_FONT_SIZE) stay local to each file.

// One threshold for the actions menu, the podium's row layout, and the table's
// column collapse, so they can't drift apart.
export const NARROW_BREAKPOINT = 820;

// Hides Change and minimizes podium rows; shared for the same reason.
export const MINIMIZED_BREAKPOINT = 480;

// Single-board width at which TV Mode starts scaling up from 1.
export const TV_SCALE_ANCHOR_WIDTH = 1024;
// How much the anchor shrinks per extra board, so 2–3 narrower boards still scale.
export const TV_SCALE_BOARD_COUNT_DAMPING = 0.2;
export const TV_SCALE_MAX = 1.6;

export const HEADER_SCALED_SIZES = {
  exerciseNameFontSize: 12,
  infoIconWrapperSize: 16,
  infoIconWrapperBorderWidth: 1,
  infoIconSize: 10,
  settingsIconSize: 15,
};

// Capped below TV_SCALE_MAX so the popup can't collide with an adjacent board
// or clip off-screen.
export const TOOLTIP_POPUP_SCALE_CAP = 1.3;
export const TOOLTIP_POPUP_SCALED_SIZES = {
  paddingY: 14,
  paddingX: 16,
  minWidth: 300,
  maxWidth: 420,
};

// Also used in BoardTableWrapper.js's tableEnd math — see BEHAVIOR.md Invariants.
export const TABLE_MARGIN_TOP = 16;

// node-server's RankPosition.getChangeDirection. Colors the Change arrow only;
// the arrow's direction comes from getChangeArrow.
export const CHANGE_DIRECTION_BETTER = 1;
export const CHANGE_DIRECTION_WORSE = 2;
